import type { BasePageConfig } from '@/pageConfig/BasePageConfig';
import ogImage from '@/static/assets/home/og.png';

export const config: BasePageConfig = {
  seo: {
    title: 'Insurance Built For the 21st Century | Lemonade',
    metaTitle: 'Lemonade: An Insurance Company Built for the 21st Century',
    description:
      'Lemonade, America’s top-rated insurance company, protects your family and your belongings—at home, and everywhere else. Sign up in seconds, get paid in minutes.',
    ogImage: ogImage.src,
  },
  layout: {
    headerActions: {
      dropdown: {
        logout: 'Log out',
        myAccount: 'My Account',
        settings: 'Settings',
      },
      CTAs: {
        backToYourQuote: {
          long: {
            singular: 'Back to your quote',
            plural: 'Back to your quotes',
          },
          short: {
            singular: 'QUOTE',
            plural: 'QUOTES',
          },
        },
        checkOurPrices: {
          long: {
            singular: 'Check our prices',
            plural: 'Check our prices',
          },
          short: {
            singular: 'Price',
            plural: 'Prices',
          },
        },
      },
    },
  },
};
